import Service from '@/services/abstract/service'

export default class Vendedor extends Service {
  constructor() {
    super()
    this._leadRef = this._db.collection(`${this._prefix}-leads`)
    this._desempenhoRef = this._db.collection(`${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Desempenho`)
    this._rankRef = this._db.collection(`${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Rank`)
  }

  async getLeadsByDateRange(dateStart, dateEnd, cpf) {
    try {
      this._loading.setLoading(true, "Carregando Leads")

      const dataFim = new Date(dateEnd)
      dataFim.setDate(dataFim.getDate() + 1)
      dataFim.setHours(23, 59, 59)

      const dataInicio = new Date(dateStart)
      dataInicio.setDate(dataInicio.getDate() + 1)
      dataInicio.setHours(0)

      const response = await this._leadRef.where("donoDoLead", "==", cpf)
        .where('dataCriacao', '>=', dataInicio)
        .where('dataCriacao', '<=', dataFim).get()

      let leads = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          leads.push(doc.data())
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getDesempenhoByMonth(cpf, empresa) {
    try {
      this._loading.setLoading(true, "Carregando Desenpenho")

      const date = new Date()
      const response = await this._desempenhoRef.where("cpf", "==", cpf)
        .where("empresa", "==", empresa)
        .where("mesAno", "==", parseInt(`${date.getMonth() + 1}${date.getFullYear()}`))
        .get()

      let desempenho = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          desempenho.push(doc.data())
        }
      }

      return Promise.resolve(desempenho[0])
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getDesempenho(filter) {
    try {
      this._loading.setLoading(true, "Carregando Desenpenho")

      const date = new Date()
      const response = await this._desempenhoRef.where("cpf", "==", filter.cpf)
        .where("mesAno", "==", filter.mesAno)
        .get()

      let desempenho = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          desempenho.push(doc.data())
        }
      }

      return Promise.resolve(desempenho[0])
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getHistoricoRanks(cpf) {
    try {
      this._loading.setLoading(true, "Carregando Historico do Rank")

      const response = await this._rankRef.where("cpf", "==", cpf)
        .orderBy("dataUltimaAtualizacao", "desc").limit(6)
        .get()

      let ranks = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          ranks.push(doc.data())
        }
      }
      return Promise.resolve(ranks)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
